/**
 * Name und Branding – an genau dieser einen Stelle.
 *
 * Domain: meetify.chat. Es gibt schon Apps mit ähnlichem Namen – vor dem öffentlichen Start im
 * Markenregister (DPMA/EUIPO) prüfen. UI, Seitentitel, App-Symbol-Name, Stripe-Produkte und
 * Server-Logs lesen den Namen von hier.
 */
export const BRAND = {
  name: 'Meetify',
  domain: 'meetify.chat',
  tagline: 'Triff neue Menschen per Video. In deiner Nähe oder irgendwo auf der Welt.',
} as const;
